// extracted by mini-css-extract-plugin
module.exports = {"background":"X_dS","shopping__wrapper__examples":"X_d2","active":"X_d3","shopping__wrapper__project":"X_d4"};